import clsx from "clsx";

interface Props {
    className?: string
    FillColor?: string
}

export default function Search({className, FillColor = 'black'}:Props) {
    return (
        <svg width="24" height="24" className={clsx(className, FillColor)}>
            <path
                d="M14.3756 15.8286C13.1893 16.7111 11.7191 17.2334 10.127 17.2334C6.19192 17.2334 3.00195 14.0434 3.00195 10.1084C3.00195 6.17337 6.19192 2.9834 10.127 2.9834C14.062 2.9834 17.252 6.17337 17.252 10.1084C17.252 11.9106 16.5829 13.5565 15.4796 14.8112L20.9092 20.2409C21.0264 20.3581 21.0264 20.548 20.9092 20.6652C20.4406 21.1338 19.6808 21.1338 19.2122 20.6652L14.3756 15.8286ZM15.752 10.1084C15.752 7.0018 13.2336 4.4834 10.127 4.4834C7.02035 4.4834 4.50195 7.0018 4.50195 10.1084C4.50195 13.215 7.02035 15.7334 10.127 15.7334C13.2336 15.7334 15.752 13.215 15.752 10.1084Z"
                fill="black"/>
        </svg>
    )
}
